import { useState, useEffect } from "react";
import { fetchUsers, claimPoints } from "../api";

export default function UserSelector({ onClaim }) {
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState("");

  useEffect(() => {
    fetchUsers()
      .then(res => setUsers(res.data))
      .catch(err => {
        console.error("Error fetching users:", err);
        alert("Failed to load users. Please try again later.");
      });
  }, []);

  const handleClaim = async () => {
    if (selectedUser) {
      try {
        const res = await claimPoints(selectedUser);
        onClaim();
        alert(`${res.data.user.name} earned ${res.data.points} points!`);
      } catch (err) {
        console.error("Error claiming points:", err);
        alert("Failed to claim points. Please try again.");
      }
    }
  };

  return (
    <div>
      <select onChange={e => setSelectedUser(e.target.value)}>
        <option>Select a user</option>
        {users.map(u => (
          <option key={u._id} value={u._id}>{u.name}</option>
        ))}
      </select>
      <button onClick={handleClaim}>Claim Points</button>
    </div>
  );
}
